export default "__VITE_ASSET__86ff9aae__"